// Extending From
import Controller from '@ember/controller';
// External Imports
import config from '@linc-technologies/linced-common/utils/config';

export default class SchoolSwitchingController extends Controller {
  // oauthBaseUrl returns the base URL for the OAuth provider.
  oauthBaseUrl = config.oauth.host;
}
